function setLocalStorage(key, value) {
    localStorage.setItem(key, value);
}

function getLocalStorage(key) {
    return localStorage.getItem(key);
}

function setThemeMode(dataAttributeValue) {
    document.documentElement.setAttribute("data-bs-theme", dataAttributeValue);
}

const themeMode = getLocalStorage("theme-mode");

if (themeMode === "auto") {
    if (window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches) {
        setThemeMode("dark");
    } else {
        setThemeMode("light");
    }
} else if (themeMode) {
    setThemeMode(themeMode);
}

document.querySelector("body").addEventListener("click", function (event) {
    const target = event.target;
    if (target.classList.contains("theme-option")) {
        const selectedTheme = target.getAttribute("data-theme-value");

        if (selectedTheme === "auto") {
            if (window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches) {
                setThemeMode("dark");
            } else {
                setThemeMode("light");
            }
        } else {
            setThemeMode(selectedTheme);
        }

        document.getElementById("ThemeSelector").textContent = "Theme: " + selectedTheme;

        setLocalStorage("theme-mode", selectedTheme);
    }
});
